import React from 'react'
import {connect} from 'react-redux'

import {
  VIEWPORT_TYPES
} from './config/constants'

const {PHONE} = VIEWPORT_TYPES

import bookmarkGroup from './data/setters/bookmark_group'
import unbookmarkGroup from './data/setters/unbookmark_group'

class GroupChatBookmarkButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.blur = this.blur.bind(this)
    this.focus = this.focus.bind(this)
    this.bookmark = this.bookmark.bind(this)
    this.unbookmark = this.unbookmark.bind(this)
  }

  blur () {
    this.setState({isFocused: false})
  }

  focus () {
    this.setState({isFocused: true})
  }

  bookmark (e) {
    if (e && e.preventDefault) e.preventDefault()
    this.setState({isFocused: false})

    this.props.bookmarkGroup(this.props.currentUserUid, this.props.groupId)
  }

  unbookmark (e) {
    if (e && e.preventDefault) e.preventDefault()
    this.setState({isFocused: false})

    this.props.unbookmarkGroup(this.props.currentUserUid, this.props.groupId)
  }

  renderLabel (text) {
    if (this.props.shouldShowLabels && this.props.viewportType !== PHONE) {
      return (
        <span style={{verticalAlign: 'middle'}}>{text}</span>
      )
    }
  }

  renderBookmarkedButton () {
    const width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto'
    const marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null

    if (this.state.isFocused) {
      return (
        <a href='#' style={this.props.style}  title='Remove from My List' className='btn btn-danger btn-sm' onMouseLeave={this.blur} onClick={this.unbookmark}>
          <div style={{width, textAlign: 'left'}}>
            <i className='rc-icon-bookmark-outline' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
            {this.renderLabel('Remove')}
          </div>
        </a>
      )
    }
    else {
      return (
        <a href='#' style={this.props.style}  className='btn btn-success btn-sm' onMouseEnter={this.focus} onTouchEnd={this.unbookmark}>
          <div style={{width, textAlign: 'left'}}>
            <i className='rc-icon-bookmark' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
            {this.renderLabel('In My List')}
          </div>
        </a>
      )
    }
  }

  renderUnBookmarkedButton () {
    const width = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? this.props.width : 'auto'
    const marginRight = this.props.shouldShowLabels && this.props.viewportType !== PHONE ? 4 : null

    return (
      <a href='#' title='Add to My List' style={this.props.style} className='btn btn-success btn-sm btn-stripped' onClick={this.bookmark}>
        <div style={{width, textAlign: 'left'}}>
          <i className='rc-icon-bookmark-outline' style={{marginRight, verticalAlign: 'middle', fontSize: 16}}/>
          {this.renderLabel('Add to My List')}
        </div>
      </a>
    )
  }

  render () {
    if (!this.props.currentUserUid) return false
    if (this.props.bookmarkedGroup) return this.renderBookmarkedButton()

    return this.renderUnBookmarkedButton()
  }
}

GroupChatBookmarkButton.defaultProps = {
  width: 94,
  shouldShowLabels: true
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUserUid: state.getIn(['currentUser', 'uid']),
    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId]),
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const mapDispatchToProps = () => {
  return {
    bookmarkGroup: bookmarkGroup,
    unbookmarkGroup: unbookmarkGroup
  }
}

const GroupChatBookmarkButtonContainer = connect(
  mapStateToProps, mapDispatchToProps
)(GroupChatBookmarkButton)

export default GroupChatBookmarkButtonContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chat_bookmark_button.js
 **/